import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useMemo, useCallback } from 'react';
import times from 'lodash/times';
import Pagination from 'components/Pagination';
const PaginatedRenderer = ({ idKey, entities, paginationClassName = null, perPage = 10, page = 0, isInProgress = false, isPerPageOff = false, onPageChange, onPerPageChange, children })=>{
    const [currentPage, setCurrentPage] = useState(page);
    const [currentPerPage, setCurrentPerPage] = useState(perPage);
    const pagedEntities = useMemo(()=>{
        if (isInProgress) {
            return times(currentPerPage, (n)=>({
                    [idKey]: n
                }));
        }
        return entities.slice(currentPerPage * currentPage, currentPerPage * (currentPage + 1));
    }, [
        entities,
        currentPage,
        currentPerPage,
        isInProgress,
        idKey
    ]);
    const totalPages = useMemo(()=>Math.ceil(entities.length / currentPerPage), [
        entities.length,
        currentPerPage
    ]);
    const handlePageChange = useCallback((nextPage)=>{
        setCurrentPage(nextPage);
        const pageChangeArgs = {
            page: nextPage,
            perPage: currentPerPage
        };
        onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(pageChangeArgs);
    }, [
        currentPerPage,
        onPageChange
    ]);
    const handlePerPageChange = useCallback((newPerPage)=>{
        setCurrentPerPage(newPerPage);
        setCurrentPage(0);
        onPerPageChange === null || onPerPageChange === void 0 ? void 0 : onPerPageChange(newPerPage);
    }, [
        onPerPageChange
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            children({
                entities: pagedEntities,
                isInProgress
            }),
            /*#__PURE__*/ _jsx(Pagination, {
                className: paginationClassName,
                perPage: currentPerPage,
                onPerPageChange: handlePerPageChange,
                onPageChange: handlePageChange,
                page: currentPage,
                totalPages: totalPages,
                isPerPageOff: isPerPageOff
            })
        ]
    });
};
export default PaginatedRenderer;
